import React, { useState, useEffect, useRef } from 'react';
import {
   Typography,
   IconButton,
   Paper,
   Box,
   Grid,
   Button,
   Divider,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import {
   tableIcons,
   tableStyle,
   headerStyle,
} from '../../../configs/ui/TableConfig';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import { Layout, myContainerStyle } from '../../../configs/ui/constant';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import {
   faFileEdit,
   faTrashAlt,
   faLink,
   faUnlink,
} from '@fortawesome/pro-duotone-svg-icons';
import { Input, TextArea } from '../../../assets/styled/Element';
import SelectIconsList from '../../Select/SelectIconsList';
import { useSnackbar } from 'notistack';
import {
   getCatIcons,
   isObject,
   reverseFormatNumber,
} from '../../../configs/helpers/utility';
import { TitleLabel } from '../../Element/LabelInputForm';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import { MySelect } from '../../Select/Select';
import { Controller, useForm } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '75%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
}));
function History(props) {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const closeRef = useRef();
   const [data, setData] = useState(props.data);
   const [resp, setResp] = useState({});
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingOptions, setIsLoadingOptions] = useState(false);
   const [respOptions, setRespOptions] = useState(null);
   const [statusList, setStatusList] = useState([
      {
         value: undefined,
         label: undefined,
         desc: undefined,
      },
   ]);
   const [trackingList, setTrackingList] = useState([
      {
         value: undefined,
         label: undefined,
      },
   ]);
   const [selectedStatus, setSelectedStatus] = useState({
      value: undefined,
      label: undefined,
      desc: undefined,
   });
   const {
      handleSubmit,
      control,
      register,
      errors,
      watch,
      setValue,
      getValues,
   } = useForm({
      defaultValues: {},
   });
   useEffect(() => {
      getData();
      getTrackingOption();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get(
         `/GSB/dashboard/reward/GetRedemptionDetail?redeemRef=${data.redeemRef}`,
      )
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   const getTrackingOption = () => {
      setIsLoadingOptions(true);
      Axios.get(`/GSB/dashboard/reward/GetTrackingOption`)
         .then((response) => {
            setRespOptions(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoadingOptions(false);
         });
   };
   useEffect(() => {
      setOptionsData();
   }, [respOptions]);
   const setOptionsData = () => {
      if (isObject(respOptions)) {
         setStatusList(
            respOptions.statusList.map((category, idx) => ({
               value: category.id,
               label: category.statusDescEn,
               desc: category.statusDescTh,
            })),
         );
         setTrackingList(
            respOptions.trackingList.map((category, idx) => ({
               value: category.id,
               label: `${category.trackingDescTh} `,
            })),
         );
      }
   };
   const handleChangeStatus = (e) => {
      if (!e) {
         setSelectedStatus({
            value: undefined,
            label: undefined,
            desc: undefined,
         });
         return false;
      } else setSelectedStatus(e);
   };
   const onSubmit = (e) => {
      sessionStorage.setItem('value', JSON.stringify(e));
      if (sessionStorage['value']) {
         const values = JSON.parse(sessionStorage.getItem('value'));
         postData(values);
      }
   };
   const postData = (values) => {
      setIsLoading(true);
      const result = {
         redeemRef: resp.redemption.redeemRef,
         shippingStatusId: values.shippingStatus
            ? values.shippingStatus.value
            : null,
         trackingVendorId: values.trackingVendor
            ? values.trackingVendor.value
            : null,
         trackingNo: values.trackingNo ? values.trackingNo : null,
         trackingUrl: values.trackingUrl ? values.trackingUrl : null,
         // detail: values.detail && values.detail,
      };
      Axios.post('/GSB/dashboard/reward/UpdateRedemption', result)
         .then((resp) => {
            enqueueSnackbar('อัพเดทรายการสำเร็จ!!', {
               variant: 'success',
            });
            props.onSuccess();
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            sessionStorage.removeItem('value');
            setIsLoading(false);
         });
   };

   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Typography variant={'h4'}>รายละเอียดของรางวัล</Typography>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
               ref={closeRef}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <Box
            display={'flex'}
            alignItems={'flex-start'}
            fontSize={20}
            width={'100%'}
         >
            {resp && (
               <React.Fragment>
                  {resp.tracking && (
                     <Box px={1} display={'flex'} width={1 / 2}>
                        <Box
                           p={2}
                           style={{
                              border: '1px solid #ccc',
                              borderRadius: '5px',
                           }}
                        >
                           <form onSubmit={handleSubmit(onSubmit)}>
                              <Typography variant={'h5'}>
                                 [ติดตามพัสดุ] ที่อยู่การจัดส่ง / ข้อมูลลูกค้า
                              </Typography>

                              <Grid container spacing={2}>
                                 <Grid item xs={6}>
                                    <TitleLabel>สถานะ</TitleLabel>
                                    <Controller
                                       as={
                                          <MySelect
                                             options={statusList}
                                             closeMenuOnSelect
                                             placeholder={
                                                resp.tracking
                                                   ? resp.tracking.statusDesc
                                                      ? resp.tracking.statusDesc
                                                      : 'เลือกสถานะ'
                                                   : 'เลือกสถานะ'
                                             }
                                             cacheOptions
                                          />
                                       }
                                       onChange={([selected]) => {
                                          handleChangeStatus(selected);
                                          return selected;
                                       }}
                                       name='shippingStatus'
                                       control={control}
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    &nbsp;
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>สถานะ (ฉลาก)</TitleLabel>
                                    <Input
                                       value={
                                          selectedStatus.desc
                                             ? selectedStatus.desc
                                             : resp.tracking
                                             ? resp.tracking.statusLabel
                                                ? resp.tracking.statusLabel
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>รหัสอ้างอิง</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.refCode
                                                ? resp.tracking.refCode
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>
                                       ChocoCRM ลิงค์ติดตามพัสดุ
                                    </TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.chocoCRMTrackingUrl
                                                ? resp.tracking
                                                     .chocoCRMTrackingUrl
                                                : ''
                                             : ''
                                       }
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>บริษัทขนส่ง</TitleLabel>
                                    <Controller
                                       as={
                                          <MySelect
                                             options={trackingList}
                                             closeMenuOnSelect
                                             placeholder={
                                                resp.tracking
                                                   ? resp.tracking.logisticsComp
                                                      ? resp.tracking
                                                           .logisticsComp
                                                      : 'เลือกขนส่ง'
                                                   : 'เลือกขนส่ง'
                                             }
                                             cacheOptions
                                          />
                                       }
                                       onChange={([selected]) => {
                                          return selected;
                                       }}
                                       name='trackingVendor'
                                       control={control}
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>เลขพัสดุ</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.trackingNo
                                                ? resp.tracking.trackingNo
                                                : ''
                                             : ''
                                       }
                                       ref={register()}
                                       name={'trackingNo'}
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>ลิงค์ติดตามพัสดุ</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.trackingUrl
                                                ? resp.tracking.trackingUrl
                                                : ''
                                             : ''
                                       }
                                       ref={register()}
                                       name={'trackingUrl'}
                                    />
                                 </Grid>
                                 {/*<Grid item xs={12}>
                        <TitleLabel>รายละเอียด</TitleLabel>
                        <TextArea
                          ref={register()}
                          name={'detail'}
                          defaultValue={
                            resp.tracking
                              ? resp.tracking.detail
                                ? resp.tracking.detail
                                : ''
                              : ''
                          }
                        />
                      </Grid>*/}
                                 <Grid item xs={12}>
                                    <Box>
                                       <Button
                                          variant='contained'
                                          color='primary'
                                          type={'submit'}
                                       >
                                          ยืนยัน
                                       </Button>
                                       <Button
                                          variant='contained'
                                          onClick={props.onClickClose}
                                       >
                                          ยกเลิก
                                       </Button>
                                    </Box>
                                 </Grid>
                                 <Divider style={{ width: '100%' }} />
                                 <Grid item xs={6}>
                                    <TitleLabel>ชื่อ</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.name
                                                ? resp.tracking.address.name
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>นามสกุล</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.surname
                                                ? resp.tracking.address.surname
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>เบอร์โทรศัพท์</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.mobileNo
                                                ? resp.tracking.address.mobileNo
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={12}>
                                    <TitleLabel>ที่อยู่</TitleLabel>
                                    <TextArea
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.address
                                                ? resp.tracking.address.address
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>ตำบล/แขวง</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.subDistrict
                                                ? resp.tracking.address
                                                     .subDistrict
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>อำเภอ/เขต</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.district
                                                ? resp.tracking.address.district
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>จังหวัด</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.province
                                                ? resp.tracking.address.province
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                                 <Grid item xs={6}>
                                    <TitleLabel>รหัสไปรษณีย์</TitleLabel>
                                    <Input
                                       defaultValue={
                                          resp.tracking
                                             ? resp.tracking.address.postalCode
                                                ? resp.tracking.address
                                                     .postalCode
                                                : ''
                                             : ''
                                       }
                                       disabled
                                    />
                                 </Grid>
                              </Grid>
                           </form>
                        </Box>
                     </Box>
                  )}
                  <Box
                     px={1}
                     flexDirection={resp.tracking ? 'column' : 'row'}
                     display={'flex'}
                     width={resp.tracking ? '50%' : '100%'}
                  >
                     <Box
                        my={!resp.tracking && 2}
                        mr={!resp.tracking && 2}
                        p={2}
                        style={{
                           border: '1px solid #ccc',
                           borderRadius: '5px',
                        }}
                     >
                        <Typography variant={'h5'}>
                           CRM : การแลกของรางวัล
                        </Typography>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <TitleLabel>รหัสอ้างอิงการแลก</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.redeemRef
                                          ? resp.redemption.redeemRef
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={12}>
                              <TitleLabel>รหัสอ้างอิงของรางวัล</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.rewardRef
                                          ? resp.redemption.rewardRef
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>สถานะ</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.statusDesc
                                          ? resp.redemption.statusDesc
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>จำนวน</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.qty
                                          ? resp.redemption.qty
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>คะแนน/ทั้งหมด</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.totalPoint
                                          ? resp.redemption.totalPoint
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>มูลค่าของรางวัล</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.rewardValue
                                          ? resp.redemption.rewardValue
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>เวลาที่แลก</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.redeemedTimeLabel
                                          ? resp.redemption.redeemedTimeLabel
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={6}>
                              <TitleLabel>เวลาที่ยกเลิก</TitleLabel>
                              <Input disabled />
                           </Grid>
                        </Grid>
                     </Box>
                     <Box
                        my={2}
                        p={2}
                        style={{
                           border: '1px solid #ccc',
                           borderRadius: '5px',
                        }}
                     >
                        <Typography variant={'h5'}>GSB Money</Typography>
                        <Grid container spacing={2}>
                           <Grid item xs={12}>
                              <TitleLabel>รหัสอ้างอิงผู้ใช้</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.redeemMessage
                                          ? resp.redemption.redeemMessage
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                           <Grid item xs={12}>
                              <TitleLabel>รหัสอ้างอิง</TitleLabel>
                              <Input
                                 defaultValue={
                                    resp.redemption
                                       ? resp.redemption.redeemMessage
                                          ? resp.redemption.redeemMessage
                                          : ''
                                       : ''
                                 }
                                 disabled
                              />
                           </Grid>
                        </Grid>
                     </Box>
                  </Box>
               </React.Fragment>
            )}
         </Box>
      </Paper>
   );
}

export default History;
